(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-image-card-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navsContainers = $('.js-image-card-carousel-nav', sliderContainer);
			const squareImages = sliderEl.hasAttribute('data-square-images');

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 12,
				slidesPerView: 'auto',
				loop: false,
				watchObserver: true,

				breakpoints: {
					1772: {
						slidesPerView: squareImages ? 'auto' : 5,
					}
				},

				on: {
					lock: function () {
						checkIfSwiperNavRequiredLock('lock', sliderEl, navsContainers);
					},

					unlock: function () {
						checkIfSwiperNavRequiredLock('unlock', sliderEl, navsContainers);
					},

					reachBeginning: function () {
						setSwiperNavAtBeginning(sliderContainer)
					},

					reachEnd: function () {
						setSwiperNavAtEnd(sliderContainer)
					},

					progress: function () {
						setSwiperNavOtherClasses(sliderContainer, this);
					}
				},
			});

			setupSwiperNavButtons(sliderContainer, swiper);
		});
	});
})(jQuery, document, window);
